// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3siw4","col":"styles_col__qcQc_"};